import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { BaseurlProvider } from '../providers/baseurl/baseurl';
import { HttpModule } from '@angular/http';
import { DataTablesModule } from 'angular-datatables';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
//import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';
//import { LoginPage } from '../pages/login/login';
// import { AddPhasePage } from '../pages/add-phase/add-phase';
// import { AddPrephasePage } from '../pages/add-prephase/add-prephase'; 
// import { EditPhasePage } from '../pages/edit-phase/edit-phase';
// import { EditPrephasePage } from '../pages/edit-prephase/edit-prephase';
//import { UserAuthPage } from '../pages/user-auth/user-auth';
// import { AddVesselDeparturePage } from '../pages/add-vessel-departure/add-vessel-departure';
// import { EditVesselDeparturePage } from '../pages/edit-vessel-departure/edit-vessel-departure';
// import { AddVesselArrivalPage } from '../pages/add-vessel-arrival/add-vessel-arrival';
// import { EditVesselArrivalPage } from '../pages/edit-vessel-arrival/edit-vessel-arrival';
// import { AddUnloadingPage } from '../pages/add-unloading/add-unloading';
// import { EditUnloadingPage } from '../pages/edit-unloading/edit-unloading';
// import { AddReturnPage } from '../pages/add-return/add-return';
// import { EditReturnPage } from '../pages/edit-return/edit-return';
//import { ReportsAllVoyagePage } from '../pages/reports-all-voyage/reports-all-voyage';
import { ReportsIntervalWisePage } from '../pages/reports-interval-wise/reports-interval-wise';
import { ReportsPartyWisePage } from '../pages/reports-party-wise/reports-party-wise';
//import { ReportsPortWisePage } from '../pages/reports-port-wise/reports-port-wise';
import { ReportsProductWisePage } from '../pages/reports-product-wise/reports-product-wise';
import { GoogleMapsAutocompletePage } from '../pages/google-maps-autocomplete/google-maps-autocomplete';
//import { UnderConstructionPage } from '../pages/under-construction/under-construction';

//import { ReportsTransporterWisePage } from '../pages/reports-transporter-wise/reports-transporter-wise';
//import { ReportsVesselWisePage } from '../pages/reports-vessel-wise/reports-vessel-wise';
//import { TrackVesselPage } from '../pages/track-vessel/track-vessel';
// import { ContactPage } from '../pages/contact/contact'; 
//import { AddConsignorPage } from '../pages/add-consignor/add-consignor';
//import { EditConsignorPage} from'../pages/edit-consignor/edit-consignor';
//import { AddConsigneePage } from '../pages/add-consignee/add-consignee';
//import { EditConsigneePage} from'../pages/edit-consignee/edit-consignee';
//import { AddLinerPage } from '../pages/add-liner/add-liner';
//import { EditLinerPage} from'../pages/edit-liner/edit-liner';
//import { AddVesselPage } from '../pages/add-vessel/add-vessel';
//import { EditVesselPage} from'../pages/edit-vessel/edit-vessel';
//import { AddTransporterPage } from '../pages/add-transporter/add-transporter';
//import { EditTransporterPage} from'../pages/edit-transporter/edit-transporter';
//import { AddCityPage } from '../pages/add-city/add-city';
//import { EditCityPage} from'../pages/edit-city/edit-city';
//import { AddPortPage } from '../pages/add-port/add-port';
//import { EditPortPage} from'../pages/edit-port/edit-port';
//import { AddUserPage } from '../pages/add-user/add-user';
//import { EditUserPage} from'../pages/edit-user/edit-user';
//import { AddProductPage } from '../pages/add-product/add-product';
//import { EditProductPage} from'../pages/edit-product/edit-product';
import { OneSignal } from '@ionic-native/onesignal';

@NgModule({
  declarations: [
    MyApp,
    //HomePage,
    ListPage,
    //LoginPage,
    // AddPhasePage,
    // AddPrephasePage,
    // EditPhasePage,
    // EditPrephasePage,
    //UserAuthPage,
    // AddVesseklDeparturePage,
    // EditVesselDeparturePage,
    // AddVesselArrivalPage,
    // EditVesselArrivalPage,
    // AddUnloadingPage,
    // EditUnloadingPage,
    // AddReturnPage,
    // EditReturnPage,
   // ReportsAllVoyagePage,
    ReportsIntervalWisePage,
    ReportsPartyWisePage,
   // ReportsPortWisePage,
    ReportsProductWisePage,
    //ReportsTransporterWisePage,
    //ReportsVesselWisePage,
    //TrackVesselPage,
    // ContactPage,
    //AddConsignorPage,
    //EditConsignorPage,
    //AddConsigneePage,
    //EditConsigneePage,
    //AddLinerPage,
    //EditLinerPage,
    //AddVesselPage,
    //EditVesselPage,
    //AddTransporterPage,
    //EditTransporterPage,
    //AddCityPage,
    //EditCityPage,
    //AddPortPage,
    //EditPortPage,
    //AddUserPage,
    //EditUserPage,
    //AddProductPage,
    //EditProductPage,
    GoogleMapsAutocompletePage,
    
  ], 
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/add-branch-modal/add-branch-modal.module#AddBranchModalPageModule', name: 'AddBranchModalPage', segment: 'add-branch-modal', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/add-user/add-user.module#AddUserPageModule', name: 'AddUserPage', segment: 'add-user', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/calculator/calculator.module#CalculatorPageModule', name: 'CalculatorPage', segment: 'calculator', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/change-password/change-password.module#ChangePasswordPageModule', name: 'ChangePasswordPage', segment: 'change-password', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/client-inquire/client-inquire.module#ClientInquirePageModule', name: 'ClientInquirePage', segment: 'client-inquire', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/client-settings/client-settings.module#ClientSettingsPageModule', name: 'ClientSettingsPage', segment: 'client-settings', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/container-info/container-info.module#ContainerInfoPageModule', name: 'ContainerInfoPage', segment: 'container-info', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/distance-calculator/distance-calculator.module#DistanceCalculatorPageModule', name: 'DistanceCalculatorPage', segment: 'distance-calculator', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/edit-doc-stuffing/edit-doc-stuffing.module#EditDocStuffingPageModule', name: 'EditDocStuffingPage', segment: 'edit-doc-stuffing', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/edit-user/edit-user.module#EditUserPageModule', name: 'EditUserPage', segment: 'edit-user', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/forgot-pwd-mobile/forgot-pwd-mobile.module#ForgotPwdMobilePageModule', name: 'ForgotPwdMobilePage', segment: 'forgot-pwd-mobile', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/home/home.module#HomePageModule', name: 'HomePage', segment: 'home', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login/login.module#LoginPageModule', name: 'LoginPage', segment: 'login', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/login-password/login-password.module#LoginPasswordPageModule', name: 'LoginPasswordPage', segment: 'login-password', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/logout/logout.module#LogoutPageModule', name: 'LogoutPage', segment: 'logout', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/news-feed/news-feed.module#NewsFeedPageModule', name: 'NewsFeedPage', segment: 'news-feed', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/news-feed-details/news-feed-details.module#NewsFeedDetailsPageModule', name: 'NewsFeedDetailsPage', segment: 'news-feed-details', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/notification-customers/notification-customers.module#NotificationCustomersPageModule', name: 'NotificationCustomersPage', segment: 'notification-customers', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/notification-details/notification-details.module#NotificationDetailsPageModule', name: 'NotificationDetailsPage', segment: 'notification-details', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/push-notification/push-notification.module#PushNotificationPageModule', name: 'PushNotificationPage', segment: 'push-notification', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reg-get-otp/reg-get-otp.module#RegGetOtpPageModule', name: 'RegGetOtpPage', segment: 'reg-get-otp', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reports-all-voyage/reports-all-voyage.module#ReportsAllVoyagePageModule', name: 'ReportsAllVoyagePage', segment: 'reports-all-voyage', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reports-port-wise/reports-port-wise.module#ReportsPortWisePageModule', name: 'ReportsPortWisePage', segment: 'reports-port-wise', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reports-transporter-wise/reports-transporter-wise.module#ReportsTransporterWisePageModule', name: 'ReportsTransporterWisePage', segment: 'reports-transporter-wise', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/reports-vessel-wise/reports-vessel-wise.module#ReportsVesselWisePageModule', name: 'ReportsVesselWisePage', segment: 'reports-vessel-wise', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-container/select-container.module#SelectContainerPageModule', name: 'SelectContainerPage', segment: 'select-container', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-docinvoice/select-docinvoice.module#SelectDocinvoicePageModule', name: 'SelectDocinvoicePage', segment: 'select-docinvoice', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-port/select-port.module#SelectPortPageModule', name: 'SelectPortPage', segment: 'select-port', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-transporter/select-transporter.module#SelectTransporterPageModule', name: 'SelectTransporterPage', segment: 'select-transporter', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-user/select-user.module#SelectUserPageModule', name: 'SelectUserPage', segment: 'select-user', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/select-vessel/select-vessel.module#SelectVesselPageModule', name: 'SelectVesselPage', segment: 'select-vessel', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/track-container/track-container.module#TrackContainerPageModule', name: 'TrackContainerPage', segment: 'track-container', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/track-vessel/track-vessel.module#TrackVesselPageModule', name: 'TrackVesselPage', segment: 'track-vessel', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/under-construction/under-construction.module#UnderConstructionPageModule', name: 'UnderConstructionPage', segment: 'under-construction', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/user-auth/user-auth.module#UserAuthPageModule', name: 'UserAuthPage', segment: 'user-auth', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/vessel-schedule/vessel-schedule.module#VesselSchedulePageModule', name: 'VesselSchedulePage', segment: 'vessel-schedule', priority: 'low', defaultHistory: [] }
  ]
}),
    HttpModule,
    DataTablesModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    //HomePage,
    ListPage,
    //LoginPage,
    // AddPhasePage,
    // AddPrephasePage,
    // EditPhasePage,
    // EditPrephasePage,
    //UserAuthPage,
    // AddVesselDeparturePage,
    // EditVesselDeparturePage,
    // AddVesselArrivalPage,
    // EditVesselArrivalPage,
    // AddUnloadingPage,
    // EditUnloadingPage,
    // AddReturnPage,
    // EditReturnPage,
   // ReportsAllVoyagePage,
    ReportsIntervalWisePage,
    ReportsPartyWisePage,
   // ReportsPortWisePage,
    ReportsProductWisePage,
    //ReportsTransporterWisePage,
    //ReportsVesselWisePage,
    //TrackVesselPage,  
    // ContactPage,
    //AddConsignorPage,
    //EditConsignorPage,
    //AddConsigneePage,
    //EditConsigneePage,
    //AddLinerPage,
    //EditLinerPage,
    //AddVesselPage,
    //EditVesselPage,
    //AddTransporterPage,
    //EditTransporterPage,
    //AddCityPage,
    //EditCityPage,
    //AddPortPage,
    //EditPortPage,
    //AddUserPage,
    //EditUserPage,
    //AddProductPage,
    //EditProductPage,
    GoogleMapsAutocompletePage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    BaseurlProvider,
    OneSignal
    
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts